export const formInputItems = [
  {
    label: 'Account number',
    placeholder: 'Account number',
    name: 'accountNumber',
    disabled: false,
  },
  {
    label: 'Phone number',
    placeholder: 'Phone number (Optional)',
    name: 'phoneNumber',
    disabled: false,
  },
  {
    label: 'Amount',
    placeholder: 'Amount',
    name: 'amount',
    disabled: false,
  },
  {
    label: 'Amount',
    placeholder: 'Amount',
    name: 'Amount',
    disabled: false,
  },
  {
    label: 'Description',
    placeholder: 'Description',
    name: 'description',
    disabled: false,
  },
  {
    label: 'Account holder',
    placeholder: 'Account holder',
    name: 'accountHolder',
    disabled: true,
  },
  {
    label: 'A/C holder name',
    placeholder: 'A/C holder name',
    name: 'holderName',
    disabled: false,
  },
  {
    label: 'Account number/IBAN',
    placeholder: 'Account number/IBAN',
    name: 'internalAccountNumber',
    disabled: false,
  },
  {
    label: 'Routing number',
    placeholder: 'Routing number',
    name: 'routingNumber',
    disabled: false,
  },
  {
    label: 'Beneficiary address',
    placeholder: 'Beneficiary address',
    name: 'beneficiaryAddress',
    disabled: false,
  },
  {
    label: 'Document ID',
    placeholder: 'Document ID',
    name: 'documentID',
    disabled: false,
  },
  {
    label: 'Tax Payer Name',
    placeholder: 'Tax Payer Name',
    name: 'taxPayerName',
    disabled: false,
  },
];

export const filteredFormInputItems = (item: string[]) => {
  const includedNames = new Set(item);
  return formInputItems.filter((item) =>
    includedNames.has(item.name),
  );
};
